import(/* webpackMode: "eager", webpackExports: ["SupportPageContent"] */ "/vercel/path0/apps/web/components/SupportPageContent.tsx");
